import { useState } from "react";
import Textarea from "../../../../componentes/input/textarea";
import AcaoButtons from "../../Shared/AcaoButtons";

// Etapa "Aprovação do Gestor" — Aprovar/Reprovar com comentário OPCIONAL. Diferente de
// EtapaPromocaoAnalise (Análise do RH), aqui os botões nunca ficam desabilitados por campo vazio:
// o comentário só é enviado em `dados` quando o gestor de fato escreveu algo.
export default function EtapaAprovacaoGestor({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const [comentario, setComentario] = useState("");

    function executar(acao) {
        const texto = comentario.trim();
        onExecutarAcao(acao, { dados: texto ? { comentarioAprovacaoGestor: texto } : {} });
    }

    return (
        <div className="flex flex-col gap-4">
            <Textarea
                label="Comentário do gestor (opcional)"
                value={comentario}
                onChange={e => setComentario(e.target.value)}
                rows={3}
                placeholder="Opcional — registre aqui uma observação sobre sua decisão."
            />
            <AcaoButtons acoes={acoes} acaoEmExecucao={acaoEmExecucao} onAcao={executar} />
        </div>
    );
}
